import React, { useEffect, useRef, useState } from "react";
import styles from "./Matchmaking.module.scss";
import { useNavigate } from "react-router-dom";
import WebSocketService from "services/WebSocketService/WebSocketService";
import { Session } from "@supabase/supabase-js";

interface MatchmakingProps {
    session?: Session;
}

const Matchmaking: React.FC<MatchmakingProps> = (props) => {
    const navigate = useNavigate();
    const [isInQueue, setIsInQueue] = useState(false);

    // Keep WebSocket instance persistent across renders
    const wsService = useRef<WebSocketService | null>(null);
    const user = {
        name: props.session?.user.user_metadata?.name || "Guest",
        email: props.session?.user.email || "No EMAIL",
        player_id: props.session?.user?.id || "",
    };

    useEffect(() => {

        if (!props.session || wsService.current) return; // Prevent multiple instances

        const handleWebSocketMessage = (data: any) => {
            console.log("Matchmaking message >>", data);

            switch (data.type) {
                case "match_found":
                    setIsInQueue(false);
                    navigate(`/game?room_id=${data.room_id}`);
                    break;
                default:
                    console.error("Unknown matchmaking message type:", data);
            }
        };

        const socketUrl = process.env.REACT_APP_SOCKET_URL + "/matchmaking" || "";
        wsService.current = new WebSocketService("matchmaking-page", socketUrl, handleWebSocketMessage, user);

        console.log("WebSocket initialized:", wsService.current);

        return () => {
            console.log("Closing WebSocket...");
            wsService.current?.closeConnection();
            wsService.current = null;
        };
    }, [props.session]);

    const enterQueue = () => {
        if (wsService.current) {
            setIsInQueue(true);
            wsService.current.sendMessage({ type: "enter_queue", player_id: user?.player_id || "" });
        } else {
            console.error("WebSocketService is not initialized.");
        }
    };

    const leaveQueue = () => {
        if (wsService.current) {
            setIsInQueue(false);
            wsService.current.sendMessage({ type: "leave_queue", player_id: user?.player_id || "" });
        } else {
            console.error("WebSocketService is not initialized.");
        }
    };

    if (!user) {
        return <div className={styles.wrapper}>Loading...</div>;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <h1>Matchmaking</h1>
                <p>Welcome, {user.name} ({user.email})!</p>
            </div>

            {!isInQueue ? (
                <div className={styles.queueControls}>
                    <button onClick={enterQueue} className={styles.button}>Enter Matchmaking</button>
                </div>
            ) : (
                <div className={styles.waitingScreen}>
                    <h2>Searching for a match...</h2>
                    <p>Hang tight while we find an opponent!</p>
                    <button onClick={leaveQueue} className={styles.cancelButton}>Cancel Matchmaking</button>
                </div>
            )}
        </div>
    );
};

export default Matchmaking;
